export enum DeviceType {
  DESKTOP = "desktop",
  MOBILE = "mobile"
}
